<script setup lang="ts">
import { ref, computed } from "vue";
import { useSearchStore } from "@/stores/search";
import RangeInput from "@/components/RangeInput/RangeInput.ce.vue";
import { pushEventDataLayer } from "@/services/funnelEvent";
import type DurationFunnelEvent from "@/types/funnel/durationFunnelEvent";
import { SELECT_CONTENT } from "@/globalConsts/searchFunnelEvents";
import { DURATION } from "@/globalConsts/searchFunnelContentTypes";
import { t } from "@/services/i18n";

const store = useSearchStore();
const { saveSubmittedDurationRatio } = store;
const durationFilter = ref(store.getCurrentDurationRange);
const durationRange = computed(() => {
    return store.getDurationRange;
});

function updateDurationFilter(value: number[]): void {
    if (value[0] && value[1]) {
        saveSubmittedDurationRatio(value[0], value[1]);
        pushEventDataLayer({
            content_type: DURATION,
            event: SELECT_CONTENT,
            max_duration: value[0],
            min_duration: value[1],
        } as DurationFunnelEvent);
    }
}
</script>
<template>
    <range-input
        @changeRangeInput="(value: number[]) => updateDurationFilter(value)"
        :range="durationRange"
        :current-value="durationFilter"
        :range-label-min="t('min_duration')"
        :range-label-max="t('max_duration')"
        :post-suffix="t('days')"
    />
</template>
